import axios from "axios";
import { del, get, post, put } from "./api_helper";
import * as url from "./glottis_url_helper";

// Login Method
const postGlottisLogin = data => post(url.GLOTTIS_POST_LOGIN, data);
const forgetPwd = data => post(url.FORGET_PASSWORD, data);
export const forgetPwdResendCode = data => post(url.FORGET_PASSWORD_RESEND_CODE, data);
const resetPwd = data => post(url.RESET_PASSWORD_URL, data);

//Clients
export const getClient = () => get(url.GET_CLIENTS);
export const postNewClient = data => post(url.POST_NEW_CLIENT, data);
export const clientUpdate = (id) => { return get(`${url.UPDATE_CLIENT}/${id}`, { params: { id }, }); };
export const clientActiveStatus = data => post(url.CLIENT_STATUS, data);

//admin
export const getAllAdmins = () => get(url.GET_ALL_ADMIN);
export const postNewAdmin = data => post(url.POST_NEW_ADMIN, data);
export const getAdminById = (id) => {
  return get(`${url.GET_ADMIN_BY_ID}/${id}`, {
    params: { id },
  });
};
export const updateStatus = data => post(url.UPDATE_STATUS, data);
export const getAdminRoles = () => get(url.GET_ADMIN_ROLES);

//user
export const getAllUser = () => get(url.GET_ALL_USER);
export const postNewUser = data => post(url.POST_NEW_USER, data);
export const getUserById = (id) => {
  return get(`${url.GET_USER_BY_ID}/${id}`, {
    params: { id },
  });
};
export const deleteUser = (id) => {
  return post(`${url.DELETE_USER}/${id}`, {
    params: { id },
  });
};
// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);
//password
export {
  postGlottisLogin,
  forgetPwd,
  resetPwd,
}

//Booking
export const getAllBookings = () => get(url.GET_ALL_BOOKINGS);

//Quotes
export const postAddQuotesSeaExportGeneralCargo = data => post(url.POST_NEW_QUOTES_SEA_EXPORT_GENERAL_CARGO, data);
export const getAllQuotes = () => post(url.GET_ALL_QUOTES);
export const getByIdQuote = (id) => {
  return get(`${url.GET_BY_ID_QUOTES}/${id}`, {
    params: { id },
  });
};
export const deleteQuote = data => del(url.DELETE_QUOTE, data);
export const quoteStatusUpdate = data => post(url.QUOTE_STATUS_UPDATE, data)
export const addNewShipper = data => post(url.ADD_AIR_SHIPPER_INFO, data)
export const getAirShipperInfoByShipperId = (id) => {
  return get(`${url.GET_BY_ID_AIR_SHIPPER_INFO}/${id}`, {
    params: { id },
  });
};
export const addSeaShipper = data => post(url.ADD_SEA_SHIPPER_INFO, data)
export const getSeaShipperInfoByShipperId = (id) => {
  return get(`${url.GET_BY_ID_SEA_SHIPPER_INFO}/${id}`, {
    params: { id },
  });
};
export const airShipperInfoStatusUpdate = data => post(url.AIR_SHIPPER_INFO_STATUS_UPDATE, data)
export const seaShipperInfoStatusUpdate = data => post(url.SEA_SHIPPER_INFO_STATUS_UPDATE, data)


//Generate password for user and admin
export const generatePwd = data => post(url.GENERATE_PASSWORD, data);

//Dashboard
export const getCounts = () => get(url.GET_COUNTS);
export const getRecentQuotes = () => get(url.GET_RECENT_QUOTES);
export const getPieChart = () => get(url.GET_PIE_CHART);
export const getBarChart = () => get(url.GET_BAR_CHART);
export const updateProfile = data => post(url.UPDATE_PROFILE, data);
export const changeLoginPassword = data => post(url.CHANGE_PASSWORD, data);

//tracking
export const trackBooking = (containerNumber) => {
  return get(`${url.TRACK_BOOKING}`, {
    params: { containerNumber }
  })
};
export const getByBookingNo = (trackId) => {
  return get(`${url.GET_BOOKING_BY_BOOKING_NO}/${trackId}`, {
    params: { trackId },
  });
};
export const getBYBookingContainerWise = (trackId, containerId) => {
  return get(`${url.GET_BOOKING_BY_CONTAINER_WISE}/${trackId}/${containerId}`, {
    params: { trackId, containerId },
  });
};

//update profile image
export const updateProfileImg = data => post(url.UPDATE_PROFILE_IMG, data);

//settings
export const postSettingsUpdate = data => post(url.SETTINGS_UPDATE, data);
export const getSettings = () => get(url.GET_SETTINGS);
export const getNotificationUrl = () => get(url.GET_NOTIFICATION);